export default "__VITE_ASSET__CxllRNBk__"